<template>
    <div></div>
</template>

<script>
export default {
    name: 'cookies-consent',
    data() {
        return {
            oneTrustId: '93e7addb-3cd3-4313-bf1c-2d3b6b72aba1-test',
        };
    },
    created() {
        const OneTrust = document.createElement('script');
        OneTrust.type = 'text/javascript';
        OneTrust.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        OneTrust.charset = 'UTF-8';
        OneTrust.setAttribute('data-document-language', 'true');
        OneTrust.setAttribute('data-domain-script', this.oneTrustId);
        // if (process.env.NODE_ENV !== 'development') {
        document.head.prepend(OneTrust);
        // }

        setTimeout(() => {
            const oneTrustPolicyDiv = document.getElementById('onetrust-policy');
            oneTrustPolicyDiv.scrollTop = 0;
        }, 900);
    },
};
</script>

<style lang="scss">

@media only screen and (max-width: 425px){
    #onetrust-banner-sdk{
         #onetrust-policy{
            height: 100px !important;
            overflow: scroll !important;
            margin-top: 1em !important;
        }
         #onetrust-button-group{
             display: flex !important;
             flex-wrap: wrap !important;
             justify-content: space-between !important;
        }
         #onetrust-accept-btn-handler{
             width: 45% !important;
         }
         #onetrust-reject-all-handler{
             width: 45% !important;
             margin-right: 0 !important;
         }
         #onetrust-pc-btn-handler{
             width: 100% !important;
             flex: 0 0 100% !important;
         }
    }
}
</style>
